import { ProgressBar } from '@tempmee/react';

const TOTAL_STEPS = 3;
const BAR_WIDTH = 480;

const STEP_SPEC = {
  1: { label: 'Your Information', percent: 30 },
  2: { label: 'Office Details', percent: 65 },
  3: { label: 'Office Setup', percent: 100 },
} as const;

export type TSignUpStep = keyof typeof STEP_SPEC;

export interface ISignUpStepProgressBarProps {
  step: TSignUpStep;
}

export const SignUpStepProgressBar = ({ step }: ISignUpStepProgressBarProps) => {
  const { label, percent } = STEP_SPEC[step];
  return (
    <ProgressBar
      value={percent}
      label={`Step ${step} of ${TOTAL_STEPS}: ${label}`}
      style={{ width: BAR_WIDTH }}
    />
  );
};
